import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {CommonModule} from '@angular/common';
import {ToastComponent} from '@shared/components/toast/toast.component';
import {LoadingOverlayComponent} from '@shared/loading-overlay/loading-overlay.component';
import {IdleService} from './core/idle/idle.service';
import {filter, map} from 'rxjs';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, ToastComponent, LoadingOverlayComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  readonly idleService = inject(IdleService);
  hideToast$ = this.router.events.pipe(
    filter((e): e is NavigationEnd => e instanceof NavigationEnd),
    map(e => e.urlAfterRedirects === '/error')
  );


  constructor(private router: Router) {
  }

  ngOnInit() {
    this.idleService.start();
  }

  ngOnDestroy(): void {
    this.idleService.stop();
  }

}
